import i18n from '@/libs/i18n'
// axios
import axios from 'axios'

const baseURL = process.env.VUE_APP_API_BASE_URL

const axiosObject = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

axiosObject.interceptors.response.use(
  response => response,
  error => {
    const response = error?.response

    if (!response) {
      return Promise.reject(error)
    }

    if (response.status === window.CONST_HTTP_STATUS_CODE_ERROR_AUTHENTICATION) {
      if (window.PRIME_VUE_OBJECT) {
        window.PRIME_VUE_OBJECT.hideLoading()
        window.PRIME_VUE_OBJECT.$store.dispatch('auth/logout')
        window.PRIME_VUE_OBJECT.alertError(i18n.t('common.unauthenticated'))
      }
      // This function will cancel all the operations
      return new Promise(() => {
      })
    }

    if (response.status === window.CONST_HTTP_STATUS_CODE_METHOD_NOT_ALLOWED) {
      if (!window.PRIME_VUE_OBJECT) {
        return new Promise(() => {
        })
      }

      window.PRIME_VUE_OBJECT.hideLoading()

      if (
        typeof response.data?.user_information === 'object'
                && response.data.user_information !== null
      ) {
        window.PRIME_VUE_OBJECT.$store.dispatch('auth/updateAdminInfo', response.data.user_information)
        return new Promise(() => {
        })
      }

      return new Promise(() => {
      })
    }

    return Promise.reject(error)
  },
)

axiosObject.updateAuthentication = apiToken => {
  axiosObject.defaults.headers.common.Authorization = `Bearer ${apiToken}`
}
axiosObject.removeAuthentication = () => {
  delete (axiosObject.defaults.headers.common.Authorization)
}

export default axiosObject
